(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lw-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lw-home')) {
    customElements.define('lw-home',class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort=new AbortController();
        const signal=this.abort.signal;
        this.rails=[...this.querySelectorAll('[data-home-product-rail]')];
        this.refresh=()=>this.rails.forEach(rail=>rail.parentElement.querySelectorAll('[data-home-rail-step]').forEach(button=>{button.hidden=rail.scrollWidth<=rail.clientWidth+2;button.disabled=Number(button.dataset.homeRailStep)<0?rail.scrollLeft<=2:rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;}));
        this.querySelectorAll('[data-home-rail-step]').forEach(button=>button.addEventListener('click',()=>{const rail=button.parentElement.querySelector('[data-home-product-rail]');rail.scrollBy({left:Number(button.dataset.homeRailStep)*rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},{signal}));
        this.rails.forEach(rail=>rail.addEventListener('scroll',this.refresh,{passive:true,signal}));
        window.addEventListener('resize',this.refresh,{passive:true,signal});
        this.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>this.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();}),{signal}));
        this.refresh();
      }
      disconnectedCallback(){this.abort?.abort();this.abort=null;this.querySelectorAll('video').forEach(video=>video.pause());}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-product-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lw-story-video')) {
    customElements.define('lw-story-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.start = () => {
          document.querySelectorAll('lw-story-video video').forEach(video => { if (video !== this.video) video.pause(); });
          if (!this.video.getAttribute('src')) this.video.src = this.dataset.videoSrc;
          this.video.loop = this.video.dataset.loop === 'true' && !this.motion.matches;
          this.classList.add('is-loaded');
          this.video.play().catch(() => {});
          this.video.focus({ preventScroll: true });
        };
        this.visibility = () => { if (document.hidden) this.video.pause(); };
        this.motionChange = () => { this.video.loop = this.video.dataset.loop === 'true' && !this.motion.matches; };
        this.onPlay = () => { document.querySelectorAll('lw-story-video video').forEach(video => { if (video !== this.video) video.pause(); }); };
        this.button.addEventListener('click', this.start);
        this.video.addEventListener('play', this.onPlay);
        this.motion.addEventListener('change', this.motionChange);
        document.addEventListener('visibilitychange', this.visibility);
        this.observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) this.video.pause(); }, { threshold: 0.05 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.video?.pause();
        this.button?.removeEventListener('click', this.start);
        this.video?.removeEventListener('play', this.onPlay);
        this.motion?.removeEventListener('change', this.motionChange);
        document.removeEventListener('visibilitychange', this.visibility);
        this.observer?.disconnect();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lw-product')) {
    class LittleWonderProduct extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => this.onClick(event), options);
        this.addEventListener('submit', (event) => this.onSubmit(event), options);
        this.addEventListener('change', (event) => {
          if (event.target.matches('[name="quantity"]')) this.normalizeQuantity();
          if (event.target.matches('[data-offer-quantity]')) {
            const input = this.querySelector('[name="quantity"]');
            input.value = event.target.value;
            this.normalizeQuantity();
          }
          if (event.target.matches('[data-offer-variant]')) {
            const index = Number(event.target.dataset.offerIndex);
            const id = Number(event.target.value);
            if (!this.offerState.variants.some((variant) => variant.id === id && variant.available)) return;
            this.offerIds[index] = id;
            this.syncOffers();
            if (index === 0) {
              const destination = new URL(this.dataset.productUrl, location.origin || location.href);
              destination.searchParams.set('variant', String(id));
              this.loadVariant(destination, null, true);
            }
          }
        }, options);
        this.addEventListener('keydown', (event) => {
          if (!event.target.matches('[data-gallery-track]') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.moveGallery(this.galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.addEventListener('scroll', (event) => {
          if (event.target.matches('[data-gallery-track]')) this.updateGallery();
        }, { capture: true, passive: true, signal: this.controller.signal });
        window.addEventListener('popstate', () => this.loadVariant(new URL(location.href), null, false), options);
        window.addEventListener('scroll', () => this.scheduleStickyVisibility(), { passive: true, signal: this.controller.signal });
        window.addEventListener('resize', () => this.scheduleStickyVisibility(), { passive: true, signal: this.controller.signal });
        this.hydrate();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.variantRequest?.abort();
        this.purchaseObserver?.disconnect();
        if (this.stickyFrame != null && window.cancelAnimationFrame) window.cancelAnimationFrame(this.stickyFrame);
        this.stickyFrame = null;
        this.controller = null;
      }

      hydrate() {
        this.state = JSON.parse(this.querySelector('[data-product-state]').textContent);
        const offerData = this.querySelector('[data-offer-state]');
        this.offerState = offerData ? JSON.parse(offerData.textContent) : null;
        const approved = this.offerState?.variants || [];
        this.offerIds = [this.state.variantId, ...[1, 2].map((index) => approved.some((variant) => variant.id === this.offerIds?.[index] && variant.available) ? this.offerIds[index] : this.state.variantId)];
        const selected = approved.find((variant) => variant.id === this.state.variantId);
        this.offerMode = Boolean(selected && selected.min === 1 && selected.step === 1);
        const offers = this.querySelector('[data-offers]');
        if (offers) offers.hidden = !this.offerMode;
        const quantityControl = this.querySelector('.lw-quantity');
        if (quantityControl) quantityControl.hidden = this.offerMode;
        if (this.offerMode) this.querySelector('[name="quantity"]').removeAttribute('max');
        if (this.state.selectionRedirect && this.state.variantId) {
          const selectedUrl = new URL(location.href);
          selectedUrl.searchParams.delete('option_values');
          selectedUrl.searchParams.delete('section_id');
          selectedUrl.searchParams.set('variant', this.state.variantId);
          history.replaceState({}, '', selectedUrl);
        }
        this.dataset.enhanced = '';
        this.querySelectorAll('[data-quantity-step]').forEach((button) => { button.hidden = false; });
        const slides = this.querySelectorAll('.lw-gallery-slide');
        this.querySelectorAll('[data-gallery-controls], [data-gallery-thumbnails]').forEach((node) => { node.hidden = slides.length < 2; });
        this.galleryIndex = 0;
        this.updateGallery();
        this.normalizeQuantity();
        this.purchaseObserver?.disconnect();
        const sticky = this.querySelector('[data-sticky-purchase]');
        const purchase = this.querySelector('[data-product-add]');
        if (sticky && purchase && window.IntersectionObserver) {
          this.purchaseObserver = new window.IntersectionObserver(() => this.scheduleStickyVisibility());
          this.purchaseObserver.observe(purchase);
        }
        this.scheduleStickyVisibility();
      }

      scheduleStickyVisibility() {
        if (!this.controller || this.controller.signal.aborted || this.stickyFrame != null) return;
        if (!window.requestAnimationFrame) { this.updateStickyVisibility(); return; }
        this.stickyFrame = window.requestAnimationFrame(() => {
          this.stickyFrame = null;
          if (this.controller && !this.controller.signal.aborted) this.updateStickyVisibility();
        });
      }

      updateStickyVisibility() {
        const sticky = this.querySelector('[data-sticky-purchase]');
        const purchase = this.querySelector('[data-product-add]');
        if (!sticky || !purchase || typeof purchase.getBoundingClientRect !== 'function') return;
        const hidden = purchase.getBoundingClientRect().bottom >= 0;
        if (sticky.hidden !== hidden) sticky.hidden = hidden;
      }

      offerItems(quantity) {
        const ids = this.offerMode && quantity > 1 && quantity <= 3 ? this.offerIds.slice(0, quantity) : Array(quantity).fill(this.state.variantId);
        const counts = new Map();
        ids.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
        return [...counts].map(([id, count]) => ({ id, quantity: count }));
      }

      validOfferItems(items) {
        return items.length > 0 && items.every((item) => {
          const variant = this.offerState?.variants.find((entry) => entry.id === item.id);
          return variant && variant.available && item.quantity >= variant.min && (item.quantity - variant.min) % variant.step === 0 && (!variant.max || item.quantity <= variant.max);
        });
      }

      offerMoney(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.offerState.currency }).format(cents / 100);
      }

      syncOffers() {
        if (!this.offerMode) return;
        const quantity = Number(this.querySelector('[name="quantity"]').value) || 1;
        const selections = this.querySelector('[data-offer-items]');
        const canMix = this.offerState.variants.filter((variant) => variant.available).length > 1;
        if (selections) selections.hidden = quantity < 2 || quantity > 3 || !canMix;
        const selectedCard = this.querySelector(`[data-offer-card="${quantity}"]`);
        if (selections && selectedCard && selections.parentElement !== selectedCard) selectedCard.append(selections);
        this.querySelectorAll('[data-offer-card]').forEach((card) => {
          const count = Number(card.dataset.offerCard);
          const items = this.offerItems(count);
          const total = items.reduce((sum, item) => sum + (this.offerState.variants.find((variant) => variant.id === item.id)?.price || 0) * item.quantity, 0);
          const saving = this.offerState.active ? Math.min(total, (count - 1) * 1000) : 0;
          const radio = card.querySelector('[data-offer-quantity]');
          radio.checked = quantity === count;
          radio.disabled = !this.state.available || this.loading || this.adding;
          card.querySelector('[data-offer-total]').textContent = this.offerMoney(total - saving);
          card.querySelector('[data-offer-original]').textContent = this.offerMoney(total);
          card.querySelector('[data-offer-original]').hidden = !saving;
          card.querySelector('[data-offer-saving]').textContent = this.offerState.labels.save.replace('[amount]', this.offerMoney(saving));
          card.querySelector('[data-offer-saving]').hidden = !saving;
        });
        this.querySelectorAll('[data-offer-slot]').forEach((slot) => {
          const index = Number(slot.dataset.offerSlot) - 1;
          slot.hidden = index >= quantity;
          const select = slot.querySelector('[data-offer-variant]');
          select.disabled = index >= quantity || this.loading || this.adding || !this.state.available;
          const selectedOption = [...select.options].find((option) => option.value === String(this.offerIds[index]));
          if (selectedOption) selectedOption.selected = true;
          const variant = this.offerState.variants.find((entry) => entry.id === this.offerIds[index]);
          const image = slot.querySelector('[data-offer-image]');
          image.hidden = !variant?.image;
          if (variant?.image) image.src = variant.image;
        });
        this.offerValid = this.validOfferItems(this.offerItems(quantity));
        const button = this.querySelector('[data-product-add]');
        if (button) button.disabled = this.loading || this.adding || !this.state.available || !this.offerValid;
        const stickyButton = this.querySelector('[data-sticky-claim]');
        if (stickyButton) stickyButton.disabled = button.disabled;
        const stickyPrice = this.querySelector('[data-sticky-price]');
        const selectedPrice = selectedCard?.querySelector('[data-offer-total]');
        if (stickyPrice && selectedPrice) stickyPrice.textContent = selectedPrice.textContent;
        const express = this.querySelector('[data-product-express]');
        if (express) { express.hidden = quantity > 1 || this.loading || this.adding; express.inert = express.hidden; }
        const error = this.querySelector('[data-product-error]');
        if (!this.offerValid && this.state.available) { error.textContent = this.offerState.labels.invalid; error.hidden = false; }
        else if (error?.textContent === this.offerState.labels.invalid) { error.hidden = true; error.textContent = ''; }
      }

      normalizeQuantity() {
        const input = this.querySelector('[name="quantity"]');
        if (!input) return;
        const min = Number(input.min) || 1;
        const step = Number(input.step) || 1;
        const max = input.max ? Number(input.max) : Number.MAX_SAFE_INTEGER;
        const raw = Number(input.value);
        const value = Number.isFinite(raw) ? raw : min;
        input.value = String(Math.min(max, Math.max(min, min + Math.floor((value - min) / step) * step)));
        this.querySelectorAll('[data-quantity-step]').forEach((button) => {
          button.disabled = Number(button.dataset.quantityStep) < 0 ? Number(input.value) <= min : Number(input.value) + step > max;
        });
        this.syncOffers();
      }

      onClick(event) {
        const stickyClaim = event.target.closest('[data-sticky-claim]');
        if (stickyClaim && this.contains(stickyClaim)) {
          event.preventDefault();
          const purchase = this.querySelector('[data-product-add]');
          if (!purchase?.disabled) this.querySelector('.lw-product-form').requestSubmit(purchase);
          return;
        }
        const link = event.target.closest('[data-option-link]');
        if (link && this.contains(link) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          if (this.adding) return;
          this.loadVariant(new URL(link.href), link.dataset.optionValueId, true);
          return;
        }
        const stepper = event.target.closest('[data-quantity-step]');
        if (stepper) {
          const input = this.querySelector('[name="quantity"]');
          this.normalizeQuantity();
          input.value = String(Number(input.value) + Number(stepper.dataset.quantityStep) * (Number(input.step) || 1));
          this.normalizeQuantity();
        }
        const thumbnail = event.target.closest('[data-gallery-image]');
        if (thumbnail) {
          const index = [...this.querySelectorAll('.lw-gallery-slide')].findIndex((slide) => slide.dataset.imageId === thumbnail.dataset.galleryImage);
          this.moveGallery(index);
        }
        const arrow = event.target.closest('[data-gallery-step]');
        if (arrow) this.moveGallery(this.galleryIndex + Number(arrow.dataset.galleryStep));
      }

      async loadVariant(destination, focusValue, updateUrl) {
        this.variantRequest?.abort();
        const request = new AbortController();
        this.variantRequest = request;
        this.loading = true;
        const quantity = this.querySelector('[name="quantity"]')?.value;
        this.setBusy(true, this.state.labels.loading);
        const requestUrl = new URL(destination);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(requestUrl, { credentials: 'same-origin', signal: request.signal });
          if (!response.ok) throw new Error(this.state.labels.loadError);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = html.getElementById(this.id);
          if (!fresh?.querySelector('[data-product-state]')) throw new Error(this.state.labels.loadError);
          if (request.signal.aborted) return;
          this.innerHTML = fresh.innerHTML;
          this.dataset.productUrl = fresh.dataset.productUrl;
          this.hydrate();
          const input = this.querySelector('[name="quantity"]');
          if (input && quantity) { input.value = quantity; this.normalizeQuantity(); }
          if (updateUrl) {
            const nextUrl = new URL(destination);
            nextUrl.searchParams.delete('section_id');
            if (this.state.variantId) {
              nextUrl.searchParams.delete('option_values');
              nextUrl.searchParams.set('variant', this.state.variantId);
            }
            history.replaceState({}, '', nextUrl);
          }
          if (focusValue) this.querySelector(`[data-option-value-id="${CSS.escape(focusValue)}"]`)?.focus({ preventScroll: true });
          this.querySelector('[data-product-status]').textContent = '';
          if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
        } catch (error) {
          if (request.signal.aborted) return;
          location.assign(destination.href);
        } finally {
          if (this.variantRequest === request) { this.loading = false; this.setBusy(false); }
        }
      }

      setBusy(busy, label) {
        this.setAttribute('aria-busy', String(busy));
        const options = this.querySelector('[data-product-options]');
        if (options) options.inert = busy;
        const button = this.querySelector('[data-product-add]');
        if (button) button.disabled = busy || !this.state.available || !this.state.variantId;
        const stickyButton = this.querySelector('[data-sticky-claim]');
        if (stickyButton) stickyButton.disabled = button.disabled;
        const express = this.querySelector('[data-product-express]');
        if (express) { express.inert = busy; express.hidden = busy; }
        const offers = this.querySelector('[data-offers]');
        if (offers) offers.inert = busy;
        const offerItems = this.querySelector('[data-offer-items]');
        if (offerItems) offerItems.inert = busy;
        this.syncOffers();
        if (label) this.querySelector('[data-product-status]').textContent = label;
      }

      async onSubmit(event) {
        const form = event.target;
        if (!form.matches('.lw-product-form')) return;
        if (event.submitter?.closest('[data-product-express]')) return;
        if (this.loading || this.adding || !this.state.available || !this.state.variantId) { event.preventDefault(); return; }
        this.normalizeQuantity();
        if (!form.reportValidity()) { event.preventDefault(); return; }
        if (this.offerMode && !this.offerValid) { event.preventDefault(); return; }
        const quantity = Number(this.querySelector('[name="quantity"]').value);
        const mixedOffer = this.offerMode && quantity > 1;
        if (!window.LittleWonderCart?.ready && !mixedOffer) return;
        event.preventDefault();
        this.adding = true;
        this.setBusy(true, this.state.labels.adding);
        const errorNode = this.querySelector('[data-product-error]');
        const recovery = this.querySelector('[data-cart-recovery]');
        errorNode.hidden = true;
        recovery.hidden = true;
        let addAccepted = false;
        try {
          const data = new FormData(form);
          data.delete('lw_offer_quantity');
          if (mixedOffer) {
            data.delete('id');
            data.delete('quantity');
            this.offerItems(quantity).forEach((item, index) => {
              data.append(`items[${index}][id]`, String(item.id));
              data.append(`items[${index}][quantity]`, String(item.quantity));
            });
          }
          const response = await fetch(this.dataset.addUrl, { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            errorNode.textContent = result.description || result.message || this.state.labels.cartError;
            errorNode.hidden = false;
            this.querySelector('[data-product-status]').textContent = '';
            return;
          }
          addAccepted = true;
          if (!window.LittleWonderCart?.ready) { location.assign(this.dataset.cartUrl); return; }
          const cartResponse = await fetch(this.dataset.cartJsonUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!cartResponse.ok) throw new Error(this.state.labels.uncertain);
          const cart = await cartResponse.json();
          this.querySelector('[data-product-status]').textContent = this.state.labels.added;
          document.dispatchEvent(new CustomEvent('lw:cart-updated', { detail: { cart, source: this } }));
        } catch (error) {
          if (addAccepted) { location.assign(this.dataset.cartUrl); return; }
          errorNode.textContent = this.state.labels.uncertain;
          errorNode.hidden = false;
          recovery.hidden = false;
          this.querySelector('[data-product-status]').textContent = '';
        } finally {
          this.adding = false;
          this.setBusy(false);
        }
      }

      moveGallery(index) {
        const track = this.querySelector('[data-gallery-track]');
        const slides = [...this.querySelectorAll('.lw-gallery-slide')];
        if (!track || !slides.length) return;
        const next = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[next].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }

      updateGallery() {
        const track = this.querySelector('[data-gallery-track]');
        const slides = [...this.querySelectorAll('.lw-gallery-slide')];
        if (!track || !slides.length) return;
        this.galleryIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))));
        const imageId = slides[this.galleryIndex].dataset.imageId;
        this.querySelectorAll('[data-gallery-image]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.galleryImage === imageId)));
        this.querySelectorAll('[data-gallery-step]').forEach((button) => { button.disabled = Number(button.dataset.galleryStep) < 0 ? this.galleryIndex === 0 : this.galleryIndex === slides.length - 1; });
        const count = this.querySelector('[data-gallery-count]');
        if (count) count.textContent = this.state.labels.imageCount.replace('[current]', this.galleryIndex + 1).replace('[total]', slides.length);
      }
    }
    customElements.define('lw-product', LittleWonderProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
